import { useRecoilState } from "recoil";
import { tokenRecaptcha } from "../atom";

const useTokenRecaptchaState = () => {
    return useRecoilState(tokenRecaptcha);
};

export default useTokenRecaptchaState;